(function () {
  var CONSENT_FIELD_SELECTOR = '.lh-form .field-consent';
  var CUSTOM_MESSAGE = 'Please check the box to confirm your agreement.';
  var observerConfig = { childList: true, subtree: true, characterData: true };

  function fixConsentErrorMessages() {
    document.querySelectorAll(CONSENT_FIELD_SELECTOR).forEach(function (field) {
      var errorEl = field.querySelector('.messages .help-block.error');

      if (errorEl) {
        errorEl.textContent = CUSTOM_MESSAGE;
      }
    });
  }

  var consentErrorObserver = new MutationObserver(function () {
    consentErrorObserver.disconnect();
    fixConsentErrorMessages();
    consentErrorObserver.observe(document.body, observerConfig);
  });

  fixConsentErrorMessages();
  consentErrorObserver.observe(document.body, observerConfig);
})();

(function () {
  var modal = document.getElementById('price-match');

  if (!modal) return;

  function lockScrollbarGutter() {
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    if (scrollbarWidth > 0) {
      document.body.style.setProperty('--price-match-scrollbar-width', scrollbarWidth + 'px');
      document.body.classList.add('price-match-scroll-lock');
    }
  }

  function unlockScrollbarGutter() {
    document.body.classList.remove('price-match-scroll-lock');
    document.body.style.removeProperty('--price-match-scrollbar-width');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('a[href="#price-match"], [data-price-match-trigger]');

    if (!trigger) return;
    if (typeof modal.show !== 'function') return;

    event.preventDefault();
    lockScrollbarGutter();
    modal.show(trigger);
  });

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'open' && !modal.hasAttribute('open')) {
        unlockScrollbarGutter();
      }
    });
  }).observe(modal, { attributes: true });
})();
